import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

export const useSignUpPage = (handleSignup) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [joinNewsletter, setJoinNewsLetter] = useState(false)
  const router = useRouter()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    const { response } = await handleSignup(email, password)
    // setSubmitted(true)

    if (response.error) {
      if (response.errorText) {
        setError(response.errorText)
      } else {
        setError('There was an error joining Fintros. Please try again.')
      }
      setLoading(false)
      return
    }

    router.push(`/verify-email/${email}`).catch((e) => {
      // workaround for https://github.com/vercel/next.js/issues/37362
      if (!e.cancelled) {
        throw e
      }
    })
    setLoading(false)
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value)
  }

  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
  }

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value)
  }

  const handleJoinNewsLetterChange = (e) => {
    setJoinNewsLetter(e)
  }

  useEffect(() => {
    setError(null)
  }, [email, password])

  return {
    handleSubmit,
    email,
    handleEmailChange,
    password,
    confirmPassword,
    handlePasswordChange,
    handleConfirmPasswordChange,
    error,
    loading,
    joinNewsletter,
    handleJoinNewsLetterChange,
  }
}
